import React from "react";
import Friends from "../../images/friends.png";
import { Fade } from "react-awesome-reveal";
import "./style.css";
function ComponentsFourth() {
  return (
    <div className="container  maindiv44">
      <div className="row ">
        <div className="col-lg-4 col-md-5 col-sm-12 mt-5 d-flex justify-content-center align-items-center flex-column mblview23324589">
          <Fade direction="up" triggerOnce="true">
            <p className="fs-1 text-white text-start mb-5 textclass44">
              Bye bye cards
            </p>
            <p className="fs-3 text-white text-start textclass144">
              Now you can have all the contact
              <br /> information of any person in your
              <br />
              app, no need to keep visiting card
              <br /> of each person
            </p>
          </Fade>
        </div>
        <div className="col-lg-4 col-md-3 col-sm-12  d-flex justify-content-center align-items-center mblview2244">
          <img className="img-fluid mblview44" src={Friends} alt="" />
        </div>
      </div>
    </div>
  );
}

export default ComponentsFourth;
